import { axiosRequest } from '@/plugins/axios-common'

export const AccountVerificationActions = {

  createUserAccountVerification ({ commit }, { login, email }) {
    return axiosRequest.post('/users/create_account_verification', { login, email })
  },

  removeUserAccountVerification ({ commit }, userId) {
    return axiosRequest.post(`/users/${userId}/remove_account_verification`, { user_id: userId })
  },

  requestUserAccountVerification ({ commit }, userId) {
    return axiosRequest.post(`/users/${userId}/request_account_verification`, { user_id: userId })
  },

  verifyUserAccount ({ commit }, token) {
    return axiosRequest.post('/users/verify_account', { token })
  },

}
